module.exports = __webpack_public_path__ + "media/packs/src/assets/images/mb-main-slide-img-55c3a9283319d7d0117552b29c15ebb8.png";